import React from "react";
import styled, { css } from "styled-components";

import MALE_IMG from '../assets/img/male.png'

import { Theme } from "../utils/theme";
import { Text } from "./Text.components";

const StyledAvatar = styled.div`
  padding: 2px;
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "100%"};
  border: 1px solid transparent;
  border-color: ${(props) =>
    props.color ? Theme.PrimaryColor : "transparent"};
  text-align: center;
  display: flex;
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
    ${(props) =>
      props.cursor &&
      css`
        cursor: ${props.cursor};
      `}

  & img {
    paddding: 0.5px;
    border-radius: ${(props) => props.borderRadius ? props.borderRadius : "100%"};
    margin: 0 5px 0 0;
    ${(props) => props.border && css` border: ${props.border}; `}
  }
`;

export class Avatar extends React.Component {
  render() {
    return (
      <StyledAvatar
        color={this.props.color}
        borderRadius={this.props.borderRadius}
        style={this.props.style}
        margin={this.props.margin}
        title={this.props.title}
        cursor={this.props.cursor}
        onClick={this.props.onClick}
      >
        <img
          src={this.props.src ?? MALE_IMG}
          height={this.props.size ?? '38px'}
          width={this.props.size ?? '38px'}
          alt={this.props.alt}
        />
        {this.props.name && <div className="">
          <Text fontSize={Theme.PrimaryFontSize} align="initial">{this.props?.status}{this.props.name}</Text>
          <Text fontSize={Theme.SecondaryFontSize} color={Theme.SecondaryTextColor} align="initial">{this.props.info}</Text>
        </div>}
      </StyledAvatar>
    );
  }
}
